import { Grid } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const HorizontalProductCardContainer = styled(Grid) `
  border: ${({ theme }) => theme.borderWidth[25]} solid ${({ theme }) => theme.color.border.base};
  border-radius: ${({ theme }) => theme.borderRadius[100]};
`;
//# sourceMappingURL=HorizontalProductCard.styled.js.map